module.exports = __webpack_public_path__ + "static/media/seo-and-web.8944e69d.svg";